export function nextFrame(fn) {
    requestAnimationFrame(() => {
        requestAnimationFrame(fn);
    });
}
